import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.995 2.428H2.427c-.89 0-1.618.728-1.618 1.618v11.33c0 .89.728 1.618 1.618 1.618h14.566c.89 0 1.619-.728 1.619-1.618V4.046c0-.89-.728-1.618-1.619-1.618m0 12.948H2.427V4.046h14.566zM4.046 5.665h3.237c.485 0 .809.323.809.809v6.474c0 .485-.324.81-.81.81H4.048c-.486 0-.81-.325-.81-.81V6.474c0-.486.324-.81.81-.81m.809 1.618v4.856h1.618V7.283zm7.283-1.618h3.237c.486 0 .81.323.81.809v6.474c0 .485-.325.81-.81.81H12.14c-.486 0-.81-.325-.81-.81V6.474c0-.486.324-.81.81-.81m.81 1.618v4.856h1.618V7.283zm-3.24 1.62c.486 0 .81-.324.81-.81 0-.485-.324-.809-.81-.809-.485 0-.809.324-.809.81 0 .485.324.809.81.809m0 3.237c.486 0 .81-.324.81-.81 0-.485-.324-.809-.81-.809-.485 0-.809.324-.809.81 0 .485.324.809.81.809"
    }, null, -1)
  ]))]))
}
export default { render: render }